/**
 * Forvaltningsrett Module Description
 * Master Grade modul for forvaltningsrett
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const FORVALTNINGSRETT_CONFIG = {
  id: 'forvaltningsrett',
  title: 'Forvaltningsrett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen forvaltningsrett med lokal AI-drevet tekstanalyse, automatisk fristberegning og generering av strukturerte klageutkast. Modulen er utviklet for å gi deg et helhetlig verktøy i møte med offentlige vedtak og forvaltningen.",
  
  aboutModule: "Forvaltningsrett-modulen gir deg verktøy for å klage på vedtak, kreve partsinnsyn og identifisere saksbehandlingsfeil fra kommunen, NAV eller andre offentlige etater, basert på forvaltningsloven og offentleglova.",
  
  features: [
    "Genererer strukturerte klager på enkeltvedtak iht. Fvl. § 28 med korrekte lovhenvisninger",
    "Begjæring om partsinnsyn (Fvl. § 18) med automatisk identifisering av innsynsrett",
    "Sjekker utredningsplikt (§ 17), forhåndsvarsel (§ 16) og habilitet (§ 6) systematisk",
    "Beregner klagefristen (3 uker) automatisk basert på vedtaksdato",
    "Verktøy for begjæring om utsatt iverksettelse (Fvl. § 42) ved hastevedtak"
  ],
  
  privacyText: "All analyse og behandling skjer lokalt på din enhet. Vedtak og dokumenter lastes ikke opp, lagres ikke på servere og deles ikke med RettVerk."
};

export function ForvaltningsrettDescription() {
  const config = FORVALTNINGSRETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default ForvaltningsrettDescription;
